var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('TinyBlock', {
    attrs: {
      "elevation": _vm.elevation,
      "tooltip": _vm.tooltip
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("content", function () {
    return [_c('StatContent', {
      attrs: {
        "title": _vm.title,
        "icon": _vm.icon,
        "size": _vm.size,
        "stat": _vm.stat,
        "subtitle": _vm.subtitle,
        "secondary-value": _vm.secondaryValue,
        "secondary-above": _vm.secondaryAbove,
        "secondary-format": _vm.secondaryFormat,
        "format": _vm.format,
        "loading": _vm.loading,
        "subtitle-color": _vm.subtitleColor,
        "variant": _vm.variant,
        "icon-shadow-only": _vm.iconShadowOnly,
        "value-suffix": _vm.valueSuffix,
        "warning": _vm.warning,
        "warning-active": _vm.warningActive,
        "warning-label": _vm.warningLabel
      },
      on: {
        "warning-click": function warningClick($event) {
          return _vm.$emit('warning-click', $event);
        }
      }
    })];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }